<template>
  <div class="VB_Print_Indicator" @click.prevent="print" title="Print Brochure">
    <Icon icon="print" /> {{ $t("print") || "Print Brochure" }}
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPrint } from "@fortawesome/free-solid-svg-icons/faPrint";
import { FontAwesomeIcon as Icon } from "@fortawesome/vue-fontawesome";

library.add(faPrint);

export default {
  components: {
    Icon,
  },

  methods: {
    print() {
      if (this.demo) {
        if (this.$route.params.client === "68") {
          window.alert(
            this.$t("preview") ||
              "Preview Only. Print your brochures in your On-Demand player. Not included with VMcast."
          );
        } else {
          window.alert(
            this.$t("inactive") ||
              "Your account is not active. Please activate your account in order to enable printing."
          );
        }
        return;
      }

      window.print();
    },
  },

  computed: {
    demo() {
      return this.$store.getters.demo;
    },
  },
};
</script>

<style scoped lang="scss">
.VB_Print_Indicator {
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: auto;
  background: rgb(29, 78, 216);
  text-align: center;
  font-weight: 400;
  font-size: 1.2rem;
  color: white;
  border-radius: 50px;
  width: 260px;
  padding: 18px 30px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.7);
  cursor: pointer;

  svg {
    margin-right: 10px;
  }

  @media print {
    display: none;
  }
}
</style>
